export enum PenaltyReason {
    FoulPlay = 1,
    InAtTheSide = 2,
    Offside = 3,
    HandsInTheRuck = 4,
    IllegalTackle = 5,
    OffFeet = 6,
    CollapsingMaul = 7,
    ScrumPenalty = 8,
    NotRollingAway = 9,
    DeliberateKnockOn = 10,
    Obstruction = 11,
    LineoutOffence = 12,
    PlayingManInTheAir = 13,
    DeliberatelyHandlingBallOutOfPlay = 14,
    Other = 15,
    DoubleMovement = 16,
    PlayingTheNine = 17,
    TacklerNotReleasing = 18,
    BallCarrierNotReleasing = 19,
    Dissent = 20,
    IllegalClearOut = 21,
    IllegalMaulEntry = 22,
    RuckAttack = 23,
    RuckDefence = 24
}